/**
 * Copyright © 2026 Adnuntius AS.
 */
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {UIRouterModule} from '@uirouter/angular';
import {ButtonsModule} from 'ngx-bootstrap/buttons';
import {CollapseModule} from 'ngx-bootstrap/collapse';
import {BsDatepickerModule} from 'ngx-bootstrap/datepicker';
import {TimepickerModule} from 'ngx-bootstrap/timepicker';

import {AdminListModule} from '../common/directives/admin-list.module';
import {AppSharedModule} from '../common/app-shared.module';
import {EventTimerComponent} from '../common/controller/event-timer.component';
import {AdnSelectComponent} from '../common/directives/adn-select/adn-select.component';
import {AuditHistoryComponent} from './widget/audit-history.component';
import {ReportRequesterComponent} from './widget/report-requester.component';
import {ReportSchedulesFormComponent} from './widget/report-schedules-form.component';
import {ReportSchedulesComponent} from './widget/report-schedules.component';
import {NextReportComponent} from '../report-schedule/next-report.component';
import {ReportUrlComponent} from '../report-schedule/report-url-component';
import {ReportHistoryComponent} from './report-history.component';
import {ReportStatusComponent} from './report-status-component';

const REPORT_WIDGETS = [
  EventTimerComponent,
  ReportRequesterComponent,
  ReportSchedulesFormComponent,
  ReportSchedulesComponent,
  AuditHistoryComponent,
  ReportHistoryComponent,
  ReportStatusComponent
];

@NgModule({
  imports: [
    AppSharedModule,
    AdminListModule,
    FormsModule,
    TranslateModule,
    UIRouterModule,
    ButtonsModule,
    CollapseModule,
    BsDatepickerModule,
    TimepickerModule,
    AdnSelectComponent,
    NextReportComponent,
    ReportUrlComponent
  ],
  declarations: REPORT_WIDGETS,
  exports: [...REPORT_WIDGETS, NextReportComponent, ReportUrlComponent]
})
export class ReportWidgetsModule {
}
